import { Spin, Alert } from 'antd';




interface LoadingParams {
    message?: string
    tip?: string
    description?: string
    style?: React.CSSProperties
}

export function Loading({
    message = "Loading... ",
    tip = 'Loading...',
    description = "Loading Data",
    style
}: LoadingParams){
    
    return  (
        <Spin tip={tip} >
            <Alert
              message={message}
              description={description}
              type="info"
              style={style ? style : undefined}
            />
          </Spin>
    )
}
